// Libs
import _ from 'lodash'

// Actions
import { changeDashboardData, changeDashboardDifferenceMedian, changeDashboardPercentageMedian } from '../Dashboard/actions'
import { signOut } from '../Deauth/actions'

// Constants
import { normalize } from '../Dashboard/constants'
import { extractValue, getDates, getPrecision } from './constants'

// Axios
import { reportAPI, serverAPI } from '../../index'

// Action types
export const CHANGE_FILTER_PANEL_VISIBLE = 'change_filter_panel_visible'
export const CHANGE_FILTER_PANEL_LOADING = 'change_filter_panel_loading'
export const CHANGE_FILTER_PANEL_PARAMS = 'change_filter_panel_params'
export const TOGGLE_FILTER_PANEL_OPTION = 'toggle_filter_panel_option'
export const TOGGLE_FILTER_PANEL_ALL = 'toggle_filter_panel_all'
export const RESET_FILTER_PANEL_PARAMS = 'reset_filter_panel_params'


export function changeFilterPanelVisible(visible) {
  return {
    type: CHANGE_FILTER_PANEL_VISIBLE,
    payload: visible,
  }
}

export function changeFilterPanelLoading(loading) {
  return {
    type: CHANGE_FILTER_PANEL_LOADING,
    payload: loading,
  }
}

export function changeFilterPanelParams(lawFirmId, selectedPeriod, companies, lawFirms, classifiers) {
  return {
    type: CHANGE_FILTER_PANEL_PARAMS,
    payload: { lawFirmId, selectedPeriod, companies, lawFirms, classifiers }
  }
}

export function toggleFilterPanelOption(key, option, multiple) {
  return {
    type: TOGGLE_FILTER_PANEL_OPTION,
    payload: { key, option, multiple }
  }
}

export function toggleFilterPanelAll(key) {
  return {
    type: TOGGLE_FILTER_PANEL_ALL,
    payload: key
  }
}

export function fetchFilterPanelReport(group, period, companies, lawFirms, regions, classifiers, loading, absoluteDate, refresh) {
  let filters = {
    companies: extractValue(companies.selected),
    law_firms: extractValue(lawFirms.selected),
    regions: extractValue(regions.selected),
    precision: 'day',
    classifiers: !_.isEmpty(classifiers) ? extractValue(classifiers.selected) : []
  }
  let date = getDates('last30days')

  if (!_.isEmpty(period.selected)) {
    const value = period.selected[0].value

    date = getDates(value)
    filters = { ...filters, precision: getPrecision(value) }
  }

  if (absoluteDate) {
    date = absoluteDate
  }

  return dispatch => {
    dispatch(changeFilterPanelLoading(true))

    serverAPI.post(`/dashboard/full/${date}`, filters)
      .then(response => {
        dispatch(changeDashboardData(response.data, 'first'))
        dispatch(changeFilterPanelLoading(false))

        // TODO: What is this?
        if (!_.isEmpty(period.selected) && !refresh) {
          dispatch(changeFilterPanelVisible(false))
        }
      })
      .catch(e => {
        switch (e.response.status) {
          case 401:
            // If is in development
            if (document.location.hostname.indexOf("localhost") !== -1) { return }

            break
          default:
            console.log(e.response)
            dispatch(changeFilterPanelLoading(false))
        }
      })

    serverAPI.post(`/dashboard/rank/law-firm/${date}`, filters)
      .then(response => {

        // This is a fix to add the total of pendencies because the API returns wrong data
        const fixPendenciesTotal = response.data.map(lawFirm => {
          const { counter_proposal, first_proposal, minute, protocol } = lawFirm.pendencies
          lawFirm.pendencies.total = counter_proposal + first_proposal + minute + protocol
          return lawFirm
        })

        dispatch(changeDashboardData(fixPendenciesTotal, 'second'))
      })
      .catch(e => {
        switch (e.response.status) {
          case 401:
            // If is in development
            if (document.location.hostname.indexOf("localhost") !== -1) { return }

            break
          default:
            console.log(e.response)
        }
      })

    serverAPI.post(`/dashboard/journey/${date}`, filters)
      .then(response => {
        dispatch(changeDashboardData(response.data, 'third'))
      })
      .catch(e => {
        switch (e.response.status) {
          case 401:
            // If is in development
            if (document.location.hostname.indexOf("localhost") !== -1) { return }
            break
          default:
            console.log(e.response)
        }
      })

    serverAPI.post(`/dashboard/rank/archive-reason/${date}`, filters)
      .then(response => {
        dispatch(changeDashboardData(response.data, 'fourth'))
      })
      .catch(e => {
        switch (e.response.status) {
          case 401:
            // If is in development
            if (document.location.hostname.indexOf("localhost") !== -1) { return }
            break
          default:
            console.log(e.response)
        }
      })

    serverAPI.post(`/dashboard/rank/expected-value/${date}`, filters)
      .then(response => {
        let differenceMedian = 0, i = 0, percentageMedian = 0
        for (let item of response.data) {
          if (item.metrics.difference_absolute) {
            i++
            differenceMedian += Number(item.metrics.difference_absolute)
            percentageMedian += Number(item.metrics.difference_percentage)
          }
        }

        differenceMedian = differenceMedian / i
        percentageMedian = percentageMedian / i

        dispatch(changeDashboardDifferenceMedian(normalize('currency', differenceMedian)))
        dispatch(changeDashboardPercentageMedian(normalize('percentage', percentageMedian)))

        dispatch(changeDashboardData(response.data, 'fifth'))
      })
      .catch(e => {
        switch (e.response.status) {
          case 401:
            // If is in development
            if (document.location.hostname.indexOf("localhost") !== -1) { return }

            break
          default:
            console.log(e.response)
        }
      })
  }
}

export function fetchFilterPanelParams(lawFirmId, selectedPeriod) {
  return dispatch => {
    serverAPI.get('/dashboard/params', {})
      .then(response => {
        const { companies, law_firms, classifiers } = response.data
        const lawFirms = law_firms

        dispatch(changeFilterPanelParams(lawFirmId, selectedPeriod, companies, lawFirms, classifiers))
      })
      .catch(e => {
        switch (e.response.status) {
          case 401:
            // If is in development
            if (document.location.hostname.indexOf("localhost") !== -1) { return }

            dispatch(signOut())
            break
          default:
            console.log(e.response)
        }
      })
  }
}

export function resetFilterPanelParams() {
  return {
    type: RESET_FILTER_PANEL_PARAMS
  }
}
